export default "__VITE_ASSET__D89f6RtL__"